import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TswpCoreUiSharedModule } from '../../common/tswp-core-ui-shared.module';
import { ProductFeatureUpgradeButtonComponent } from './product-feature-upgrade-button.component';
import { ProductFeatureUpgradeButtonInitializer } from './product-feature-upgrade-button.bootstrapper';
import {
  PRODUCT_FEATURE_UPGRADE_BUTTON_CONFIG,
  ProductFeatureUpgradeButtonConfig,
} from './product-feature-upgrade-button.config';
import { ProductFeatureUpgradeTranslationService } from '../../services/product-feature-upgrade-translation.service';

@NgModule({
  imports: [CommonModule, TswpCoreUiSharedModule],
  declarations: [ProductFeatureUpgradeButtonComponent],
  providers: [
    ProductFeatureUpgradeButtonInitializer,
    ProductFeatureUpgradeTranslationService,
  ],
  exports: [ProductFeatureUpgradeButtonComponent],
})
export class ProductFeatureUpgradeButtonModule {
  /**
   * Registers the button along with the carrier-supplied
   * {@link ProductFeatureUpgradeButtonConfig} (e.g. the compare-plans URL read
   * from the carrier's environment files). Import via `forRoot` in the carrier's
   * root module; other importers can use the plain module without a URL.
   */
  public static forRoot(
    config: ProductFeatureUpgradeButtonConfig
  ): ModuleWithProviders<ProductFeatureUpgradeButtonModule> {
    return {
      ngModule: ProductFeatureUpgradeButtonModule,
      providers: [
        { provide: PRODUCT_FEATURE_UPGRADE_BUTTON_CONFIG, useValue: config },
      ],
    };
  }
}
